import React from 'react';
import { Heart, Candy, Coins } from 'lucide-react';
import sweetyLogo from '../assets/sweety.png'

// Animated background element component
const FloatingCandy = ({ className }) => (
  <div className={`absolute animate-bounce ${className}`}>
    <Candy className="w-12 h-12 text-pink-400 transform rotate-12" />
  </div>
);

const FloatingHeart = ({ className }) => (
  <div className={`absolute animate-pulse ${className}`}>
    <Heart className="w-20 h-20 text-pink-300" />
  </div>
);

const SweetyTokenPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-100 to-pink-100 flex flex-col items-center py-8 px-4 relative overflow-hidden">
      {/* Floating Background Elements */}
      <FloatingCandy className="top-1/4 left-1/4" />
      <FloatingCandy className="top-1/3 right-1/4 delay-300" />
      <FloatingCandy className="bottom-1/4 left-1/3 delay-500" />
      <FloatingHeart className="top-1/2 right-1/3 delay-700" />
      <FloatingHeart className="bottom-1/3 right-1/4 delay-1000" />
      <FloatingHeart className="top-1/3 left-1/3 delay-200" />

      {/* Hero Section with enhanced animations */}
      <div className="flex flex-col items-center mb-12 relative">
        <div className="w-32 h-32 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full flex items-center justify-center mb-6 animate-bounce shadow-lg mt-2">
          <div className="w-28 h-28 bg-white rounded-full flex items-center justify-center shadow-lg mt-2"> 
            <img src = {sweetyLogo} alt="Sweety Logo" className="w-20 h-20" />
          </div>
        </div>
        <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500 mb-4 text-center animate-pulse">
          SWEETY
        </h1>
        <p className="text-xl text-gray-700 text-center max-w-2xl">
          The sweetest memecoin on the Kadena blockchain! 🍬✨
        </p>
      </div>

      {/* Enhanced Features Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mb-12">
        {[
          {
            icon: Candy,
            title: "Sweet Rewards",
            description: "Earn delicious rewards for holding SWEETY tokens"
          },
          {
            icon: Coins,
            title: "Fair Launch",
            description: "Generated using TokenGo for maximum transparency"
          },
          {
            icon: Heart,
            title: "Community",
            description: "Join our sweet community of token holders"
          }
        ].map((feature, index) => (
          <div key={index} className="bg-white bg-opacity-50 backdrop-blur-xs p-6 rounded-2xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
            <div className="bg-pink-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
              <feature.icon className="w-8 h-8 text-pink-500" />
            </div>
            <h3 className="text-xl font-bold text-pink-500 mb-2">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>

      {/* Enhanced CTA Section */}
      <div className="text-center mb-12 relative">
        <button className="bg-gradient-to-r from-pink-500 to-purple-500 text-white text-lg font-bold py-4 px-8 rounded-full hover:from-pink-600 hover:to-purple-600 transition-colors transform hover:scale-105 duration-300 shadow-lg">
          Buy SWEETY Now
        </button>
      </div>

      {/* Enhanced Stats Section */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl">
        {[
          { value: "100M", label: "Total Supply" },
          { value: "90%", label: "Locked LP" },
          { value: "5%", label: "Marketing and Team" },
          { value: "5%", label: "Rewards" }
        ].map((stat, index) => (
          <div key={index} className="bg-white bg-opacity-50 backdrop-blur-xs p-4 rounded-xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
            <p className="text-2xl font-bold bg-gradient-to-r from-pink-500 to-purple-500 text-transparent bg-clip-text">
              {stat.value}
            </p>
            <p className="text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SweetyTokenPage;